import SendImageDialog from './SendImageDialog';

export default SendImageDialog;
